import { render, staticRenderFns } from "./scoreTable.vue?vue&type=template&id=7c2471e8&scoped=true"
import script from "./scoreTable.vue?vue&type=script&lang=js"
export * from "./scoreTable.vue?vue&type=script&lang=js"
import style0 from "./scoreTable.vue?vue&type=style&index=0&id=7c2471e8&prod&lang=css"
import style1 from "./scoreTable.vue?vue&type=style&index=1&id=7c2471e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2471e8",
  null
  
)

export default component.exports